/* eslint-disable @typescript-eslint/explicit-function-return-type */

import { BulkUpdateFormDrawer } from "@ryde/layout";
import { RydeUiUnit } from "@ryde/shared";

export const BulkUpdateFormForceEntityDrawer = ({
  forceEntity,
}: {
  forceEntity: RydeUiUnit;
}) => {
  return <BulkUpdateFormDrawer forceEntity={forceEntity} />;
};
